export default {
  cypher: {},
};
